import type { PetitionEdit } from '../../types';

// eslint-disable-next-line complexity
export function getPetitionStrengthScore(petition: PetitionEdit): number {
	let totalPointsAchieved = 0;
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (petition.description?.length < 500) {
		totalPointsAchieved += 2;
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	} else if (petition.description?.length < 2000) {
		totalPointsAchieved += 3;
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	} else if (petition.description?.length >= 2000) {
		totalPointsAchieved += 5;
	}

	// Petition Image
	if (petition.photo?.petitionLarge) {
		totalPointsAchieved += 3;
	}

	// More than 0 Decision Makers
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if ((petition.primaryDecisionMakerConnection?.totalCount || 0) > 0) {
		totalPointsAchieved += 1;
	}

	// More than 1 category tag
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if ((petition.tagsConnection?.nodes?.length || 0) > 1) {
		totalPointsAchieved += 1;
	}
	return totalPointsAchieved;
}
